/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfShippingMethodDto } from '../../models/paginated-dto-of-shipping-method-dto';

export interface GetAllShippingMethods$Params {
}

export function getAllShippingMethods(http: HttpClient, rootUrl: string, params?: GetAllShippingMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfShippingMethodDto>> {
  const rb = new RequestBuilder(rootUrl, getAllShippingMethods.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfShippingMethodDto>;
    })
  );
}

getAllShippingMethods.PATH = '/api/v1/shipping-methods';
